$(document).ready(function() {
    var CADESCOM_CADES_BES = 1;
    var CAPICOM_CURRENT_USER_STORE = 2;
    var CAPICOM_MY_STORE = "My";
    var CAPICOM_STORE_OPEN_MAXIMUM_ALLOWED = 2;
    var CAPICOM_CERTIFICATE_FIND_SUBJECT_NAME = 1;
    var CADESCOM_HASH_ALGORITHM_CP_GOST_3411 = 100;
    var CADESCOM_BASE64_TO_BINARY = 1;

    function check_if_plugin() {
        try {
            var oAbout = CreateObject("CAdESCOM.About");
            plugin_loaded();
        } catch (err) {
            // Объект создать не удалось, проверим, установлен ли
            // вообще плагин. Такая возможность есть не во всех браузерах
            var mimetype = navigator.mimeTypes["application/x-cades"];
            if (mimetype) {
                var plugin = mimetype.enabledPlugin;
                if (plugin) {
                    $('#pluginInfo').html(" Плагин загружен, но не создаются обьекты");
                    $('#pluginCheck').removeClass('fa-check').addClass('fa-close');
                    $('#linkToCrypto').show();
                } else {
                    $('#pluginInfo').html(" Ошибка при загрузке плагина");
                    $('#pluginCheck').removeClass('fa-check').addClass('fa-close');
                    $('#linkToCrypto').show();
                }
            } else {
                $('#pluginInfo').html(" Плагин недоступен");
                $('#pluginCheck').removeClass('fa-check').addClass('fa-close');
                $('#linkToCrypto').show();
            }
        }
    }

    $('#signatureModal').on('shown.bs.modal', function() {
        $('#dataToSign').val($('#dataToSignOnPage').val());
        $("#certificatesWrapper").hide();
        $('#certificatesContainer').html("");
        $('#signatureInfo').show();

    });



    function GetCertificates() {
        return new Promise(function(resolve, reject) {
            cadesplugin.async_spawn(function*(args) {
                var oStore = yield cadesplugin.CreateObjectAsync("CAdESCOM.Store");
                if (!oStore) {
                    alert("Хранилище сертификато не обнаружено.");
                    return;
                }

                try {
                    yield oStore.Open();
                } catch (ex) {
                    alert("Ошибка при открытии хранилища: " + cadesplugin.getLastError(ex));
                    return;
                }

                var certCnt;
                var certs;

                try {
                    certs = yield oStore.Certificates;
                    certCnt = yield certs.Count;
                } catch (ex) {
                    var errormes = document.getElementById("boxdiv").style.display = '';
                    return;
                }

                if (certCnt == 0) {
                    var errormes = document.getElementById("boxdiv").style.display = '';
                    return;
                }

                var CertList = [];
                for (var i = 1; i <= certCnt; i++) {
                    var cert;
                    try {
                        cert = yield certs.Item(i);
                    } catch (ex) {
                        alert("Ошибка при перечислении сертификатов: " + cadesplugin.getLastError(ex));
                        return;
                    }
                    var name = yield cert.SubjectName;
                    var public_cert = yield cert.Export(0);
                    var thumbprint = yield cert.Thumbprint;
                    var version = yield cert.Version;
                    var ValidToDate = yield cert.ValidToDate;
                    CertList.push({
                        "Cert": cert,
                        "SubjectName": name,
                        "Thumb": thumbprint,
                        "Public": public_cert,
                        "Version": version,
                        "ValidToDate": ValidToDate
                    });
                }

                yield oStore.Close();
                args[0](CertList);
            }, resolve, reject);
        });
    }

    function SignCreate(cert, dataToSign) {
        return new Promise(function(resolve, reject) {
            cadesplugin.async_spawn(function*(args) {
                try {
                    var oStore = yield cadesplugin.CreateObjectAsync("CAPICOM.Store");
                    yield oStore.Open(CAPICOM_CURRENT_USER_STORE, CAPICOM_MY_STORE,
                        CAPICOM_STORE_OPEN_MAXIMUM_ALLOWED);

                    var oSigner = yield cadesplugin.CreateObjectAsync("CAdESCOM.CPSigner");
                    yield oSigner.propset_Certificate(cert);

                    var oSignedData = yield cadesplugin.CreateObjectAsync("CAdESCOM.CadesSignedData");
                    yield oSignedData.propset_Content(dataToSign);

                    var sSignedMessage = yield oSignedData.SignCades(oSigner, CADESCOM_CADES_BES);

                    yield oStore.Close();

                    args[2]({
                        "sign": sSignedMessage,
                        "thumb": cert.Thumbprint,
                        "public": cert.Export(0)
                    });
                } catch (e) {
                    args[3]("Failed to create signature. Error: " + cadesplugin.getLastError(e));
                }
            }, cert, dataToSign, resolve, reject);
        });

    }

    function GetCertificates_NPAPI() {
        try {
            var oStore = cadesplugin.CreateObject("CAPICOM.Store");
            oStore.Open(CAPICOM_CURRENT_USER_STORE, CAPICOM_MY_STORE,
                CAPICOM_STORE_OPEN_MAXIMUM_ALLOWED);

            var oCertificates = oStore.Certificates;

            if (oCertificates.Count == 0) {
                alert("Сертификаты для ЭП не обнаружены.");
                return;
            }

            return oCertificates;
        } catch (err) {
            throw ("Failed to create signature. Error: ");
            $('#certificatesError').html('Плагин КриптоПРО не загружен. Убедитесь в актуальности версии плагина и разрешении его использования на данной странице. <br/><br/>Перейдите в ПУСК — КРИПТО ПРО — Настройки ЭП Browser Plug-in и убедитесь, что 392.eskigov.ru есть в доверенных сайтах. При появлении сообщения о загрузке плагина непосредственно в браузере — нажмите «Разрешить»<br/><br/><br/> ');

        }
    }

    function SignCreate_NPAPI(cert, dataToSign) {
        var oStore = cadesplugin.CreateObject("CAPICOM.Store");
        oStore.Open(CAPICOM_CURRENT_USER_STORE, CAPICOM_MY_STORE,
            CAPICOM_STORE_OPEN_MAXIMUM_ALLOWED);

        var oSigner = cadesplugin.CreateObject("CAdESCOM.CPSigner");
        oSigner.Certificate = cert;

        var oSignedData = cadesplugin.CreateObject("CAdESCOM.CadesSignedData");
        // Значение свойства ContentEncoding должно быть задано
        // до заполнения свойства Content
        oSignedData.ContentEncoding = CADESCOM_BASE64_TO_BINARY;
        oSignedData.Content = dataToSign;

        var sSignedMessage = "";
        // alert(oSigner);
        try {

            sSignedMessage = oSignedData.SignCades(oSigner, CADESCOM_CADES_BES, true);
        } catch (err) {
            throw ("Failed to create signature. Error: " + cadesplugin.getLastError(err));
        }
        oStore.Close();
        return sSignedMessage;
    }

    $('#loadCertificates').click(function() {
        try {
            var currentCertificates = GetCertificates_NPAPI();
            $('#signatureInfo').hide();
            if (currentCertificates.Count > 0) {
                $('#certificatesWrapper').show();

                for (var i = 1; i <= currentCertificates.Count; i++) {
                    var cert;
                    try {
                        cert = currentCertificates.Item(i);
                    } catch (ex) {
                        alert("Ошибка при перечислении сертификатов: " + cadesplugin.getLastError(ex));
                        return;
                    }

                    certText = "<li class='list-group-item list-group-item-secondary user-certificates' id='" + i + "'><span class='certSubj'>" + cert.SubjectName + "</span><div class='agile-detail'><input type='hidden' name='certFingerprint' value='" + cert.Thumbprint + "'/><a href='#' class='pull-right btn btn-xs btn-white'>Версия: " + cert.Version + "</a><i class='fa fa-clock-o'></i> " + cert.ValidToDate + "</div></li>";

                    $('#certificatesContainer').prepend(certText);
                }

            } else {
                $('#certificatesContainer').html("Установленных сертификатов в вашей системе не найдено.");
            }

            $('.user-certificates').click(function() {
                $('.user-certificates').removeClass('list-group-item-success').addClass('list-group-item-secondary');
                $(this).addClass('list-group-item-success');
                if ($('#signData').html() == 'Подпись формируется...') {
                    $('#signData').html('Подписать повторно');
                }

                $('#signData').prop('disabled', false);
            });

            $('#signData').click(function() {
                var dataToSign = $('#dataToSign').val();
                $('#signData').html('Подпись формируется...');
                $('#signData').prop("disabled", true);

                var selectedCert = currentCertificates.Item(parseInt($('.list-group-item-success').attr('id')));
                $.when(
                    SignCreate_NPAPI(selectedCert, dataToSign)
                ).done(function(x) {
                    // $('#signatureValue').html("<small>"+x+"</small>");
                    alert('Подпись сформирована!');
                    $('#signatureValueOnPage').val(x);
                    $('#certificateValueOnPage').val(selectedCert.Export(0));
                    $('#thumbprint').val(selectedCert.Thumbprint);
                    $('#certificate').val(selectedCert.Export(0));
                    $('#subjectName').val(selectedCert.SubjectName);
                    $('#releaseSignature').prop("disabled", false);
                    $('#signatureIcon').addClass('text-warning');
                    $('#signatureNotice').html('Подпись сформирована!');
                    $('#signatureModal').modal('hide');
                    $('#signData').html('Подписать повторно');
                    $('#signData').trigger('signed');

                    // survey actions
                    $('#sign-conclusion').hide();
                    $('#conclusion').append(
                        "<i class='fa fa-certificate text-warning m-l-xs'></i>"
                    );
                    $('.survey-action').show().removeClass('disabled');
                });


            })

        } catch (e) {


            GetCertificates().then(
                function(CertList) {
                    var currentCertificates = CertList;

                    $('#signatureInfo').hide();
                    try {
                        var certCnt = currentCertificates.length;
                        if (certCnt == 0)
                            throw "Cannot find object or property. (0x80092004)";
                    } catch (ex) {
                        console.log(ex);
                        oStore.Close();
                        return;
                    }

                    if (certCnt > 0) {

                        $('#certificatesWrapper').show();

                        for (var i = 0; i <= certCnt; i++) {
                            var cert;
                            try {
                                cert = CertList[i];
                            } catch (ex) {
                                alert("Ошибка при перечислении сертификатов: " + cadesplugin.getLastError(ex));
                                return;
                            }
                            try {
                                var certText = "<li class='list-group-item list-group-item-secondary user-certificates' id='" + i + "'><span class='certSubj'>" + cert.SubjectName + "</span><div class='agile-detail'><input type='hidden' name='certFingerprint' value='" + cert.Thumb + "'/><a href='#' class='pull-right btn btn-xs btn-white'>Версия: " + cert.Version + "</a><i class='fa fa-clock-o'></i> " + cert.ValidToDate + "</div></li>";

                                $('#certificatesContainer').prepend(certText);
                            } catch (e) {
                                // console.log(123)
                            }
                        }

                    } else {
                        $('#certificatesContainer').html("Установленных сертификатов в вашей системе не найдено.");
                    }

                    $('.user-certificates').click(function() {
                        $('.user-certificates').removeClass('list-group-item-success').addClass('list-group-item-secondary');
                        $(this).addClass('list-group-item-success');
                        if ($('#signData').html() == 'Подпись формируется...') {
                            $('#signData').html('Подписать повторно');
                        }
                        var selectedCert = currentCertificates[parseInt($('.list-group-item-success').attr('id'))];
                        
                        $('#signData').prop('disabled', false);

                    });


                    $('#signData').click(function() {
                        var dataToSign = $('#dataToSign').val();
                        $('#signData').html('Подпись формируется...');
                        $('#signData').prop("disabled", true);

                        var selectedCert = currentCertificates[parseInt($('.list-group-item-success').attr('id'))];
                        try {
                            $.when(
                                SignCreate_NPAPI(selectedCert, dataToSign)
                            ).done(function(x) {
                                // $('#signatureValue').html("<small>"+x+"</small>");
                                $('#signatureValueOnPage').val(x);
                                $('#certificateValueOnPage').val(selectedCert.Export(0));
                                $('#thumbprint').val(selectedCert.Thumbprint);
                                $('#certificate').val(selectedCert.Export(0));
                                $('#subjectName').val(selectedCert.SubjectName);
                                $('#releaseSignature').prop("disabled", false);
                                $('#signatureIcon').addClass('text-warning');
                                $('#signatureNotice').html('Подпись сформирована!');
                                $('#signatureModal').modal('hide');
                                $('#showSignatureModal').hide();
                                $('#sendOrder').show();
                                $('#signData').html('Подписать повторно');
                                $('#signData').trigger('signed');

                                // survey actions
                                $('#sign-conclusion').hide();
                                $('#conclusion').append(
                                    "<i class='fa fa-certificate text-warning m-l-xs'></i>"
                                );
                                $('.survey-action').show().removeClass('disabled');

                            });
                        } catch (e) {
                            var thenable = SignCreate(selectedCert.Cert, dataToSign);
                            thenable.then(
                                function(sign) {
                                    $('#signatureValueOnPage').val(sign['sign']);
                                    $('#certificateValueOnPage').val(selectedCert.Public);
                                    console.log(selectedCert.Cert.Thumbprint);
                                    $('#thumbprint').val(selectedCert.Thumb);
                                    $('#certificate').val(selectedCert.Public);
                                    $('#subjectName').val(selectedCert.SubjectName);
                                    $('#releaseSignature').prop("disabled", false);
                                    $('#signatureIcon').addClass('text-warning');
                                    $('#signatureNotice').html('Подпись сформирована!');
                                    $('#signatureModal').modal('hide');
                                    $('#showSignatureModal').hide();
                                    $('#sendOrder').show();
                                    $('#signData').html('Подписать повторно');
                                    $('#signData').trigger('signed');
                                },
                                function(result) {
                                    alert(result);
                                }
                            )
                        };
                    });

                });

        }

    }); // get certificates



});